module.exports = __webpack_public_path__ + "static/media/tw.33dd636f.svg";